import type { FuseResult, IFuseOptions } from 'fuse.js'
import type { MaybeRefOrGetter } from 'vue'

import Fuse from 'fuse.js'

export type FuseOptions<T> = IFuseOptions<T>
export interface UseFuseOptions<T> {
  fuseOptions?: FuseOptions<T>
  resultLimit?: number
  matchAllWhenSearchEmpty?: boolean
}

export const getSearchOptions = (keys: string[] = ['label']) => ({
  matchAllWhenSearchEmpty: true,
  fuseOptions: {
    keys,
    threshold: 0.3,
    isCaseSensitive: false,
  },
})

export const useSearch = <DataItem>(
  search: MaybeRefOrGetter<string>,
  data: MaybeRefOrGetter<DataItem[]>,
  options?: MaybeRefOrGetter<UseFuseOptions<DataItem>>,
) => {
  const fuse = computed(() => new Fuse(toValue(data) ?? [], toValue(options)?.fuseOptions))

  const setResults = () => {
    const resolved = toValue(options)
    /**
     * Также будет пересчитываться при изменении `data`, так как
     * изменяет инстанс Fuse, который тут отслеживается
     */
    if (resolved?.matchAllWhenSearchEmpty && !toValue(search)) {
      return toValue(data)?.map((item, index) => ({ item, refIndex: index })) || []
    }

    const limit = resolved?.resultLimit

    return fuse.value.search(toValue(search), limit ? { limit } : undefined)
  }

  const results = computed<FuseResult<DataItem>[]>(() => setResults())

  watch(
    () => toValue(data),
    (newData) => {
      fuse.value.setCollection(newData)
    },
    { deep: true },
  )
  return {
    results,
  }
}

export type UseFuseReturn = ReturnType<typeof useSearch>
